import { configureStore } from '@reduxjs/toolkit';
import uiSlice from './ui-Slice';
import dataSlice from './data-Slice';
import authSlice from './auth-Slice';

const store = configureStore({
    reducer: { ui: uiSlice.reducer, data: dataSlice.reducer, auth: authSlice.reducer }
});

export default store;